export default interface ColorContentModel {
  colorHex: string;
}

export const getColor = (
  model?: ColorContentModel,
  defaultColor?: string
): string | undefined => (model && model.colorHex) || defaultColor;
